import '../css/app.scss';

import Header from './components/header';
import ScrollAnimation from './components/scrollAnimation';
// import Toplink from './components/toplink';
import ResponsiveSlider from './components/responsiveSlider';
import MobileSlider from './components/mobileSlider';
import Quotes from './components/quotes';

import Filter from './components/filter';
import Video from './components/video';
import Accordion from './components/accordion';


$(() => {
	$('html').removeClass('loading');

	new ScrollAnimation();

	const $header = $('[data-header="el"]');

	if($header.length) {
		new Header($header);
	}

	// const $toplink = $('[data-toplink="el"]');

	// if($toplink.length) {
	// 	new Toplink($toplink);
	// }

	const $responsiveSlider = $('[data-responsive-slider="el"]');

	$responsiveSlider.each((index, el) => {
		new ResponsiveSlider($(el));
	});

	const $mobileSlider = $('[data-mobile-slider="el"]');

	$mobileSlider.each((index, el) => {
		new MobileSlider($(el));
	});

	const $quotes = $('[data-quotes="el"]');
	$quotes.each((index, el) => {
		new Quotes($(el));
	});

	
	const $filter = $('[data-filter="el"]');
	$filter.each((index, el) => {
		new Filter($(el));
	});

	const $video = $('[data-video="el"]');
	$video.each((index, el) => {
		new Video($(el));
	});

	const $accordion = $('[data-accordion="el"]');
	$accordion.each((index, el) => {
		new Accordion($(el));
	});
});
